// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/askos/reader/ContentReaderPage.css
 * Scoped under .reader-shell — this page is mounted inside AskosDashboard's
 * .app-shell, so it also inherits --navy/--gold/etc. custom properties.
 */
.reader-shell {
    padding: 4px;
}

.reader-shell .select-none {
    -webkit-user-select: none;
            user-select: none;
}

.reader-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.reader-content {
    background: #fff;
    border: 1px solid var(--line, #dfe6ef);
    border-radius: 14px;
    padding: 28px 32px;
    max-width: 820px;
    margin: 0 auto;
    line-height: 1.7;
    font-size: 15px;
}

.reader-item {
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--line, #dfe6ef);
}

.reader-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.reader-item h3 {
    font-family: "Libre Baskerville", serif;
    color: var(--navy, #092957);
    margin-top: 0;
}

.reader-item-badge {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--gold, #b8860b);
    background: rgba(184, 134, 11, 0.12);
    border-radius: 4px;
    padding: 1px 7px;
    margin-bottom: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/askos/reader/ContentReaderPage.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;IACI,YAAY;AAChB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* frontend/src/askos/reader/ContentReaderPage.css\n * Scoped under .reader-shell — this page is mounted inside AskosDashboard's\n * .app-shell, so it also inherits --navy/--gold/etc. custom properties.\n */\n.reader-shell {\n    padding: 4px;\n}\n\n.reader-shell .select-none {\n    user-select: none;\n}\n\n.reader-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.reader-content {\n    background: #fff;\n    border: 1px solid var(--line, #dfe6ef);\n    border-radius: 14px;\n    padding: 28px 32px;\n    max-width: 820px;\n    margin: 0 auto;\n    line-height: 1.7;\n    font-size: 15px;\n}\n\n.reader-item {\n    margin-bottom: 32px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--line, #dfe6ef);\n}\n\n.reader-item:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.reader-item h3 {\n    font-family: \"Libre Baskerville\", serif;\n    color: var(--navy, #092957);\n    margin-top: 0;\n}\n\n.reader-item-badge {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--gold, #b8860b);\n    background: rgba(184, 134, 11, 0.12);\n    border-radius: 4px;\n    padding: 1px 7px;\n    margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
